import {useMemo, useRef} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {MyColumns} from './columns/_columns'
import {Dealer} from '../core/_models'
import {ListLoading} from '../components/loading/ListLoading'
import { ListPagination } from '../components/pagination/ListPagination'
import {KTCardBody, KTSVG} from '../../../../../../../_metronic/helpers'
import { DownloadTableExcel } from 'react-export-table-to-excel';  

const MyTable = () => {
  const Dealer = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => Dealer, [Dealer])
  const columns = useMemo(() => MyColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  const tableRef = useRef(null);
  return (
    <KTCardBody className='py-1'>
      <div className='table-responsive'>
      <DownloadTableExcel
        filename="dealer_master "
        sheet="Dealer"
        currentTableRef={tableRef.current}
      >
        <span style={{ "position": "absolute", "top": "55px", "right": "14px" }}>
          <button type='button' className='btn btn-primary' >
            <KTSVG path='/media/icons/duotune/files/fil021.svg' className='svg-icon-2' />
            Export excel
          </button>
        </span>
      </DownloadTableExcel>

        <table
        ref={tableRef}
          id='kt_table_dealres'
          className='table align-middle table-row-dashed fs-6 gy-2 dataTable yes-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-white fw-bolder fs-7 text-uppercase gs-0 bg-primary'>
              {headers.map((column: ColumnInstance<Dealer>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-700 fw-bold fs-7' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Dealer>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ListPagination />
      {isLoading && <ListLoading />}
    </KTCardBody>
  )
}

export {MyTable}

